import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/button'
import { createModal } from '@/components/modalize/mui'
import { colors } from '@/styles'
import { CautionIcon } from '@/components/icons'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fcf5d8;
  height: 112px;
  width: 100%;
`

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: 24px;
`

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  width: 100%;
  button {
    width: 100%;
  }
`

const Title = styled.h5`
  font-size: 24px;
  line-height: 32px;
  font-weight: 700;
`

const Paragraph = styled.div`
  font-size: 16px;
  line-height: 24px;
  color: ${colors.grey48};
  margin: 8px 0 24px;
`

const LimitModal = () => {
  const { t } = useTranslation()

  const handleExit = () => {
    if (typeof window === 'undefined') return
    window.open('/app/chat/support-room', '_blank')
  }

  return (
    <Container>
      <IconWrapper>
        <CautionIcon />
      </IconWrapper>
      <TextWrapper>
        <Title>{t('r.profile.edit.credit_check_modal_title', 'Limit reached')}</Title>
        <Paragraph>
          {t(
            'r.profile.edit.credit_check_modal_text',
            'The maximum of 3 address changes have been made. If you are experiencing difficulties, please reach out to liv.rent support for assistance.'
          )}
        </Paragraph>
        <ButtonWrapper>
          <Button theme="primary" onClick={handleExit}>
            {t('r.profile.edit.credit_check_modal_button', 'Contact Support')}
          </Button>
        </ButtonWrapper>
      </TextWrapper>
    </Container>
  )
}

const showLimitReachedModal = createModal(LimitModal, { showClose: true, width: '416px' })

export default showLimitReachedModal
